// extracted by mini-css-extract-plugin
export default {"about-page":"about-page__1XLEu","about-hero":"about-hero__3T64y","about-section-with-bg":"about-section-with-bg__1x5V1","about-partners":"about-partners__1YLQv"};